import React from "react"
import { Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { MultilangJob } from "src/services/api/document"

const formatter = (currency: string) => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: currency,
  currencyDisplay: 'code'
})

export const FixedPrice = ({ multilangJob }: { multilangJob: MultilangJob }) => {
  const { t } = useTranslation('multilang')
  const total = multilangJob.cost || multilangJob.quotedTotalCost
  return total ? <>
    <Typography>{t('price')}</Typography>
    <Typography variant="h5" noWrap>{formatter(multilangJob?.currency || 'EUR').format(total)}</Typography>
  </> : <></>
}